import { CurrencyPipe, getLocaleCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { locale } from 'moment';

const PHONE_WIDTH = 660;

@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
  constructor(private readonly currency: CurrencyPipe) {}

  transform(amountInPennies: number, currency?: string): string {
    const minFractionDigits = screen.width < PHONE_WIDTH ? 0 : 2;
    const digitsInfo = `1.${minFractionDigits}-2`;
    return this.currency.transform(
      amountInPennies / 100,
      currency || getLocaleCurrencySymbol(locale()),
      'symbol-narrow',
      digitsInfo,
    );
  }

  formatCurrencySymbol(currency: string): string {
    return this.currency.transform(0, currency, 'symbol-narrow').charAt(0);
  }
}
